"use client";

import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, TextBody, TextHeading } from "@opensea/ui-kit";
import { OnboardingSelectOption } from "./OnboardingSelectOption";
export function OnboardingSelect(t0) {
  const $ = _c(17);
  const {
    title,
    description,
    options,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <TextHeading className="text-center" size="lg">{title}</TextHeading>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description) {
    t2 = description ? <TextBody color="text-secondary" size="sm">{description}</TextBody> : null;
    $[2] = description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <FlexColumn className="items-center gap-2">{t1}{t2}</FlexColumn>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onSelect || $[8] !== options) {
    let t5;
    if ($[10] !== onSelect) {
      t5 = option => <OnboardingSelectOption key={option.id} onSelect={() => {
        onSelect(option);
      }} option={option} />;
      $[10] = onSelect;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = options.map(t5);
    $[7] = onSelect;
    $[8] = options;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <Flex className="w-full flex-col justify-center gap-4 md:flex-row md:gap-6">{t4}</Flex>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <FlexColumn className="scrollbar-hidden size-full items-center gap-6 overflow-y-scroll px-6 pt-6 pb-12 md:h-auto md:gap-10 md:px-0 md:pt-0 md:pb-24">{t3}{t5}</FlexColumn>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}